import { useQuery } from "@tanstack/react-query";
import { Typo, emptyPage, Page } from "@/model";
import typoRepository from "@/repository/typoRepository";


const getData = async (agentId: number, page: number, size: number, order: 'asc' | 'desc', keyword?: string) => {
    const res = await typoRepository.find(agentId, page, size, order, keyword);
    return res.data?.data || emptyPage<Typo>();
};

export const usePaginatedTypos = (agentId: number, page: number, size: number, order: 'asc' | 'desc', keyword?: string) => {
    return useQuery<Page<Typo>>({
        queryKey: ["page-typo", "agent", agentId, "page", page, "size", size, "order", order, "keyword", keyword],
        queryFn: async () => getData(agentId, page, size, order, keyword),
        retry: false
    });
};
